<template>
  <div class="footer">
    <div class="footer__container">
      <div class="container__link">
        <div class="link__left">
          <!-- pc footer link start -->
          <div class="link__wrapper" v-for="linkItem in linkList" :key="linkItem.title">
            <p class="title">{{ linkItem.title }}</p>
            <div class="wrapper__link--item">
              <a :href="subLink.link" target="_blank" rel="nofollow noopener noreferrer" v-for="subLink in linkItem.children" :key="subLink.title">{{
                subLink.title
              }}</a>
            </div>
          </div>
          <!-- pc footer link stop -->
          <!-- mobile footer link start -->
          <div class="link__wrapper mobile" v-for="linkItem in linkList" :key="`${linkItem.title}_mobile`">
            <p class="title" @click="toggleSubLink(linkItem)">
              <span>{{ linkItem.title }}</span>
              <i class="icon bm-iconfont-new" :class="linkOpenStatus[linkItem.key] ? 'up' : ''">&#xe610;</i>
            </p>
            <div class="wrapper__link--item" :class="linkOpenStatus[linkItem.key] ? 'show' : ''">
              <a :href="subLink.link" target="_blank" rel="nofollow noopener noreferrer" v-for="subLink in linkItem.children" :key="subLink.title">{{
                subLink.title
              }}</a>
            </div>
          </div>
          <!-- mobile footer link stop -->
        </div>
        <div class="link__right">
          <p class="title">{{ $t('nft_common.social_media') }}</p>
          <div class="media-list">
            <a :href="item.link" v-for="item in mediaList" :key="item.code" target="_blank" rel="nofollow noopener noreferrer">
              <span class="iconfont2" v-html="item.code"></span>
            </a>
          </div>
        </div>
      </div>
      <div class="container__copyright">
        {{ $t('nft_common.copyright') }}
      </div>
      <div class="container__copyright--mobile" v-html="$t('nft_common.copyright_mobile')"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from '~/common/js/patch'
import commonMixin from '@/mixins/common'
import { ZENDESK_LANG_MAP } from '@/common/js/utils'

export default {
  mixins: [commonMixin],
  data() {
    return {
      isAppIOS: true,
      // mobile 底部footer 对应link组是否展开
      linkOpenStatus: {
        company: true,
        product: false,
        service: false,
        support: false,
      },
      mediaList: [
        {
          link: 'https://www.facebook.com/bitmartexchange',
          code: '&#xe66e;',
        },
        {
          link: 'https://twitter.com/BitMartNFT',
          code: '&#xe655;',
        },
        {
          link: 'https://www.reddit.com/r/BitMartExchange/',
          code: '&#xe700;',
        },
        {
          link: 'https://www.linkedin.com/company/bitmart',
          code: '&#xe92b;',
        },
        {
          link: 'https://www.youtube.com/c/BitMartExchange',
          code: '&#xe763;',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
    }),
    linkList() {
      let careerLink
      if (this.locale === 'cn') {
        careerLink = '/html/user_zendesk_sso?redirect=hc/en-us/categories/10942109789723-Career-Opportunities'
      } else {
        careerLink = '/html/user_zendesk_sso?redirect=hc/en-us/categories/10942109789723-Career-Opportunities'
      }

      const list = [
        {
          title: this.$t('nft_common.company'),
          key: 'company',
          children: [
            {
              title: this.$t('nft_common.about_us'),
              link: `/about/${this.locale}`,
            },
            {
              title: this.$t('nft_common.careers'),
              link: careerLink,
            },
            {
              title: this.$t('nft_common.partners'),
              link: `/partner/${this.locale}`,
            },
            {
              title: this.$t('nft_common.news'),
              link:
                this.locale === 'cn'
                  ? '/html/user_zendesk_sso?redirect=/hc/zh-cn/sections/360000817854-%E5%AA%92%E4%BD%93%E6%8A%A5%E9%81%93'
                  : '/html/user_zendesk_sso?redirect=/hc/en-us/sections/360000817854-Media-',
            },
            {
              title: this.$t('nft_common.cipholio_ventures'),
              link: 'https://www.cipholio.com',
            },
          ],
        },
      ]
      // if (!this.isAppIOS) {
      //   list.push({
      //     title: this.$t('nft_common.product'),
      //     key: 'product',
      //     children: [
      //       {
      //         title: this.$t('nft_common.marketplace'),
      //         link: `/nft/${this.locale}/marketplace`,
      //       },
      //     ],
      //   })
      // }
      list.push(
        {
          title: this.$t('nft_common.service'),
          key: 'service',
          children: [
            {
              title: this.$t('nft_common.help_center'),
              link: `/html/user_zendesk_sso?redirect=/hc/${ZENDESK_LANG_MAP.get(this.locale)}`,
            },
            {
              title: this.$t('nft_common.user_agreement'),
              link:
                this.locale === 'cn'
                  ? '/html/user_zendesk_sso?redirect=/hc/en-us/articles/115004890354-BITMART-USER-AGREEMENT'
                  : '/html/user_zendesk_sso?redirect=/hc/en-us/articles/115004890354-Terms-of-Use',
            },
            {
              title: this.$t('nft_common.privacy_policy'),
              link: '/html/user_zendesk_sso?redirect=/hc/en-us/articles/6292994502427-Terms-and-Conditions-for-BitMart-NFT-Marketplace',
            },
          ],
        },
        {
          title: this.$t('nft_common.support'),
          key: 'support',
          children: [
            {
              title: this.$t('nft_common.apply_to_list'),
              link: 'https://forms.gle/g26ipTpjqfgAUFMRA',
            },
            {
              title: this.$t('nft_common.marketing_cooperation'),
              link:
                this.locale === 'cn'
                  ? '/html/user_zendesk_sso?redirect=/hc/zh-cn/articles/360001865494-%E4%B8%8E%E6%88%91%E4%BB%AC%E5%90%88%E4%BD%9C'
                  : '/html/user_zendesk_sso?redirect=/hc/en-us/articles/360001865494-Cooperate-with-BitMart',
            },
            {
              title: this.$t('nft_common.contact_us'),
              link:
                this.locale === 'cn'
                  ? '/html/user_zendesk_sso?redirect=/hc/zh-cn/articles/360001860173-%E8%8E%B7%E5%BE%97%E5%B8%AE%E5%8A%A9'
                  : '/html/user_zendesk_sso?redirect=/hc/en-us/articles/360001860173-Want-to-Get-Help-from-BitMart',
            },
            {
              title: this.$t('nft_common.official_veritifition'),
              link: `/verification/${this.locale}`,
            },
          ],
        }
      )
      return list
    },
  },
  mounted() {
    this.$$isApp().then((isApp) => {
      import('amfe-env').then((env) => {
        this.isAppIOS = isApp && env.os.isIOS
      })
    })
  },
  methods: {
    toggleSubLink(item) {
      this.linkOpenStatus[item.key] = !this.linkOpenStatus[item.key]
    },
  },
}
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding-top: 120px;
  .footer__container {
    width: 1200px;
    margin: auto;
    box-sizing: border-box;
    .container__link {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .link__left {
        flex: 1;
        display: flex;
        align-items: flex-start;
      }
      .link__wrapper {
        flex: 1;
        .title {
          font-size: 14px;
          color: #1a1b1f;
          margin-bottom: 24px;
        }
        .wrapper__link--item {
          font-size: 14px;
          color: #91a5b1;
          a {
            display: block;
            margin-bottom: 16px;
          }
        }
      }
      .link__right {
        .media-list {
          color: #91a5b1;
          font-size: 20px;
          display: flex;
          margin-top: 24px;
          a {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            text-align: center;
            line-height: 48px;
            &:hover {
              color: #1a1b1f;
              background: #f5f9fb;
            }
            .iconfont2 {
              font-size: 20px;
            }
          }
        }
      }
    }
    .container__copyright {
      font-size: 14px;
      text-align: center;
      color: #91a5b1;
      line-height: 68px;
      border-top: 1px solid #eeeeee;
      margin-top: 38px;
    }
  }
}

@media screen and (min-width: 769px) {
  .container__copyright--mobile {
    display: none;
  }
  .link__wrapper {
    display: block;
    &.mobile {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .footer {
    padding-top: 60px;
    .footer__container {
      width: 100%;
      padding: 0 24px;
    }
    .container__link {
      flex-direction: column;
      width: 100%;
      .link__left {
        flex-direction: column;
        width: 100%;
      }
      .link__wrapper {
        &.mobile {
          display: block;
          width: 100%;
        }
        &:not(.mobile) {
          display: none;
        }
        .title {
          font-weight: 600;
          font-size: 20px !important;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .icon {
            transition: all 0.3s ease;
            &.up {
              transform: rotate(180deg);
            }
          }
        }
        .wrapper__link--item {
          visibility: hidden;
          transition: max-height 0.3s ease;
          max-height: 0;
          &.show {
            visibility: visible;
            max-height: 400px;
          }
        }
      }
    }
    .container__copyright {
      display: none !important;
    }
    .container__copyright--mobile {
      display: block !important;
      box-sizing: border-box;
      padding: 25px 0;
      color: #888;
      font-size: 12px;
      border-top: 1px solid #eee;
      text-align: center;
      margin-top: 25px;
    }
    .link__right {
      width: 100%;
      .title {
        font-weight: 600;
        font-size: 20px;
      }
      .media-list {
        justify-content: space-between;
        width: 100%;
        a {
          background: #fafafa !important;
          color: #888888 !important;
        }
      }
    }
  }
}
</style>
